import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminPricePropertyView, AdminTreatmentPropertyStatus } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminPricePropertyView = asBuilder((): AdminPricePropertyView => {
  const names = faker.helpers.multiple(
    () => ({
      language: faker.helpers.enumValue(TargetLanguage),
      value: faker.lorem.word(),
    }),
    { count: 3 },
  )

  return {
    id: faker.string.uuid(),
    names,
    status: faker.helpers.enumValue(AdminTreatmentPropertyStatus),
    values: faker.helpers.multiple(() => ({
      id: faker.string.uuid(),
      names,
    })),
  }
})
